import React from 'react';
import { saveAs } from 'file-saver';
// import { XLSX } from 'xlsx';
import * as XLSX from 'xlsx/xlsx.mjs';
import { Button } from 'react-bootstrap';
import { APP_COLOR } from '../../const';

const DownloadExcelButton = () => {
    const handleDownload = () => {
        const excelData = [
            [
                "ລະຫັດ Barcode", "ຊື່ສິນຄ້າ", "ຫົວຫນວ່ຍ", "ຂະໜາດ", "ຈໍານວນ", "ລາຄາຕົ້ນທືນ", "ລາຄາ 1", "ລາຄາ 2", "ລາຄາ 3", "ສະກຸນເງິນ", "ປະເພດສີນຄ້າ", "ແບຣນ", "ແບຣນຍ່ອຍ", "ຄ່າຈັດສົ່ງ"
            ],
            [
                "00001", "ກະເປົາ", "ຜືນ", "1x2", 1, 59000, 56000, 46000, 36000, "ກີບ", 'ເຄື່ອງນຸ່ງ', 'adidas', '', 10000
            ],
            [
                "00002", "ເສື້ອກັນໜາວ", "ຜືນ", "1x20", 1, 59000, 56000, 46000, 36000, "ກີບ", 'ເຄື່ອງນຸ່ງ', 'adidas', '', 10000
            ],
            [
                "00003", "ເກີບຄັດມັນ", "ຜືນ", "1x20", 2, 50, 45, 40, 35, "ບາດ", 'ເຄື່ອງນຸ່ງ', 'adidas', '', 5
            ],
            [
                "00004", "ແວ່ນຕາ", "ຜືນ", "1x1", 1, 590, 490, 390, 290, "ບາດ", 'ເຄື່ອງໃຊ້ທົ່ວໄປ', 'adidas', '', 5
            ],
            [
                "00005", "ຊຸດເດັກນ້ອຍ", "ຜືນ", "1x20", 5, 60, 50, 40, 30, "ໂດລາ", 'ເຄື່ອງນຸ່ງ', 'adidas', '', 0.5
            ],
            [
                "00006", "ຊຸດນອນ", "ຜືນ", "1x20", 2, 10, 9, 8, 7, "ໂດລາ", 'ເຄື່ອງນຸ່ງ', 'adidas', '', 0.5
            ],
            [
                "00007", "ເຄື່ອງຈອດໄຟຟ້າ", "ໜ່ວຍ", "1x20", 2, 20, 18, 16, 14, "ໂດລາ", 'ໄຟຟ້າ', 'adidas', '', 0.5
            ]
        ];


        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Convert the workbook to an array buffer
        const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Save the Excel file using FileSaver.js
        const file = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(file, 'bbbb_example_stocks.xlsx');

        // const file = new Blob([excelData], { type: 'application/vnd.ms-excel' });
        // saveAs(file, 'lailaolab-sample-excel-file.xls');
    };

    return (
        <Button onClick={handleDownload} style={{ borderColor: APP_COLOR, width: 200, color: APP_COLOR, backgroundColor: 'transparent', fontWeight: 'bold', whiteSpace: 'nowrap' }}>ດາວໂຫຼດຕົວຢ່າງ Excel</Button>
    );
};

export default DownloadExcelButton;
